export default __webpack_public_path__ + "static/media/25M.0a8ef260.jpeg";